import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import { getVODExperiments } from 'api/public/experiments/experiments';
import { parseExperimentsFromUrl } from 'shared/utils/experiments';
import WixSDK from 'shared/utils/wix-sdk';

const ACTIONS = createAsyncActions('SERVER.EXPERIMENTS');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;

const getExperimentsFromUrl = () =>
  WixSDK.Settings.getSiteInfo().then(parseExperimentsFromUrl);

export function getExperimentsFromFrameUrl() {
  return function(dispatch) {
    dispatch(START());
    const experiments = parseExperimentsFromUrl({ url: location.href });
    dispatch(SUCCESS({}, { ...experiments }));
  };
}

export default function() {
  return function(dispatch) {
    dispatch(START());

    return Promise.all([getVODExperiments(), getExperimentsFromUrl()])
      .then(args => _.merge(...args))
      .then(
        function(experiments) {
          dispatch(SUCCESS({}, experiments));
          return experiments;
        },

        function(response) {
          dispatch(
            FAIL({}, response, {
              analytics: { type: 'error', name: 'shared.experiments.get' },
            }),
          );
        },
      );
  };
}
